module.exports = __webpack_public_path__ + "fonts/momentum-ui-icons.woff";